import { css } from 'styled-components';

export const iconButton = css`
  padding: 0;
  border: none;
  background: none;
  color: black;
`;
